

<template>
  <div id="loadingoverlay" v-if="loading">
    <div class="d-flex justify-content-center">
      <div id="loading-spinner" class="spinner-border text-info" role="loading">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
#loadingoverlay {
  z-index: 1000;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.1);
}
#loading-spinner {
  width: 4rem;
  height: 4rem;
  margin-top: 10vh;
}
</style>

<script setup>

import { ref } from 'vue'
const loading = ref(false)

</script>
